import { EnvConfiguration } from '../../app/config/EnvConfiguration.ts';
import { useInstance } from '../../support/ioc/useInstance';
import { Page } from '../../components/page/Page.tsx';
import { PropsList } from './PropsList.tsx';
import { HistoryViewModel } from '../../app/HistoryViewModel.ts';
import { Network } from '../Network.ts';
import { useSubscription } from '@autopylot-internal/state';
import { DisplayMetricsProvider } from '../DisplayMetricsProvider.ts';
import { Device } from '../Device.ts';
import { AppInfo } from '../AppInfo.ts';

/**
 * This is the non-admin version of DebugPage
 * All non-admin users have access to this page
 * It shows a subset of the information on DebugPage
 */
export const TechnicalInfoPage: React.FC = () => {

    const history = useInstance(HistoryViewModel);
    const config = useInstance(EnvConfiguration);
    const displayMetrics = useInstance(DisplayMetricsProvider).getMetrics();
    const appInfo = useInstance(AppInfo);
    const deviceInfo = useInstance(Device);
    const network = useInstance(Network);
    useSubscription(() => network);

    return (
        <Page title="Technical Info" onBack={() => history.back()}>
            <div style={{ padding: 20 }}>

                <h5>App</h5>
                <PropsList info={{
                    version: appInfo?.version,
                    build: appInfo?.build,
                    sha: process.env.VITE_APP_SHA?.substring(0, 7),
                    environment: config.ENV,
                }} />

                <h5>Device</h5>
                <PropsList info={{
                    name: deviceInfo.name,
                    model: deviceInfo.model,
                    platform: deviceInfo.platform,
                    osVersion: deviceInfo.osVersion,
                    network: network.isOnline ? 'online': 'offline',
                    screen: `${displayMetrics.screen.width}x${displayMetrics.screen.height}@${displayMetrics.devicePixelRatio}`,
                    viewport: `${displayMetrics.viewport.width}x${displayMetrics.viewport.height}@${displayMetrics.devicePixelRatio}`,
                    statusBarHeight: displayMetrics.statusBarHeight,
                    navigationBarHeight: displayMetrics.navigationBarHeight,
                    webViewVersion: deviceInfo.webViewVersion,
                    memUsed: deviceInfo.memUsed,
                }} />
            </div>
        </Page>
    );
};
